import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../login/login.css";
import { createResetData } from "../../hooks/api/utils";
import { showToast } from "../../components/toaster/showToast";
import CommonModal from "../../components/modal/modal";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ email: "" });
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(60); 
  const [resendAvailable, setResendAvailable] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.email) return;
    setLoading(true);
    const payload = { ...form };
    createResetData(
      "/users/forget-password/",
      setLoading,
      payload,
      () => {
        setShowOtpModal(true);
        setTimer(60); // reset timer
        setResendAvailable(false);
        startTimer();
      }
    );
  };

  const handleOtpChange = (val, index) => {
    const newOtp = [...otp];
    newOtp[index] = val.slice(-1); // only 1 digit
    setOtp(newOtp);
    // Auto-focus next input
    if (val && index < 3) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

//   const verifyOtp = () => {
//     const otpCode = otp.join("");
//     if (otpCode.length !== 4) {
//       showToast("Please enter a 4-digit OTP");
//       return;
//     }
//     setLoading(true);
//     createResetData(
//       "/users/change-password-otp-verify/",
//       setLoading,
//       { email: form.email, otp: otpCode },
//       () => {
//         navigate("/reset-password");
//       }
//     );
//   };
const verifyOtp = () => {
  const otpCode = otp.join("");
  if (otpCode.length !== 4) {
    showToast("Please enter a 4-digit OTP");
    return;
  }
  setLoading(true);
  createResetData(
    "/users/change-password-otp-verify/",
    setLoading,
    { email: form.email, otp: otpCode },
    () => {
      navigate("/new-password", { state: { email: form.email } });
    }
  );
};


  const startTimer = () => {
    let countdown = 60;
    const interval = setInterval(() => {
      countdown -= 1;
      setTimer(countdown);
      if (countdown <= 0) {
        clearInterval(interval);
        setResendAvailable(true);
      }
    }, 1000);
  };

  const handleResendOtp = () => {
    if (!resendAvailable) return;
    createResetData(
      "/users/forget-password/",
      setLoading,
      { email: form.email },
      () => {
        setOtp(["", "", "", ""]);
        setTimer(60);
        setResendAvailable(false);
        startTimer();
        // toast.success("OTP resent");
      }
    );
  };

  return (
    <div className="main-container">
      <div className="main-content">
        <section className="form_part space-cmn">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="signupTab">
                  <div className="formArea loginmain">
                    <form onSubmit={handleSubmit}>
                      <div className="row g-4">
                        <div className="col-md-12 text-center">
                          <h4 className="fs-3 fw-bold">Forgot Password</h4>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <label>Email</label>
                            <input
                              type="email"
                              name="email"
                              className="form-control"
                              placeholder="Enter your email"
                              value={form.email}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <button type="submit" className="black_btn" disabled={loading}>
                            {loading ? "Submitting..." : "Submit"}
                          </button>
                        </div>
                      </div>
                    </form>

                    {/* OTP Modal */}
                    <CommonModal
                      isOpen={showOtpModal}
                      onRequestClose={() => setShowOtpModal(false)}
                      title="OTP Verification"
                    >
                      <p className="text-center mb-3">
                        Enter 4-digit verification code sent to <strong>{form.email}</strong>
                      </p>
                      <div className="d-flex justify-content-center gap-2 mb-2">
                        {otp.map((digit, index) => (
                          <input
                            key={index}
                            id={`otp-${index}`}
                            type="text"
                            value={digit}
                            maxLength={1}
                            className="otp-input-box"
                            onChange={(e) => handleOtpChange(e.target.value, index)}
                          />
                        ))}
                      </div>
                      <div className="text-center mb-2">
                        <span className="text-success">{`00:${timer < 10 ? "0" + timer : timer}`}</span>
                      </div>
                      <button className="black_btn w-100" onClick={verifyOtp} disabled={loading}>
                        {loading ? "Verifying..." : "VERIFY"}
                      </button>
                      {resendAvailable && (
                        <div className="text-center mt-2">
                          <small>
                            The code has expired.{" "}
                            <span
                              className="text-primary"
                              style={{ cursor: "pointer" }}
                              onClick={handleResendOtp}
                            >
                              Resend
                            </span>
                          </small>
                        </div>
                      )}
                    </CommonModal>
                  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ForgotPassword;
